<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
           <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['factory']">
              <a-select v-model="queryParam.factoryId" :options="factoryOptions" 
              :placeholder="language['common.pleaseInput']+language['factory']">
               </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['danger.areaCode']">
              <a-input :placeholder="language['common.pleaseInput']+language['danger.areaCode']" v-model="queryParam.areaCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['danger.areaName']" >
              <a-input :placeholder="language['common.pleaseInput']+language['danger.areaName']" v-model="queryParam.areaName"></a-input>
            </a-form-item>
          </a-col>
            
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search" v-has="'area:search'">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px" v-has="'area:reset'">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'area:add'">{{language['common.insertButton']}}</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('区域表')" v-has="'area:export'">{{language['common.exportButton']}}</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{language['common.delete']}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} 
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-has="'area:export'">{{language['common.edit']}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="language['common.deleteConfirmInfo']" :okText="language['common.okButton']" :cancelText="language['common.cancel']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <ep-bd-factory-area-modal ref="modalForm" @ok="modalFormOk"></ep-bd-factory-area-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { getAction,putAction } from '@/api/manage'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EpBdFactoryAreaModal from './modules/EpBdFactoryAreaModal'

  export default {
    name: 'EpBdFactoryAreaList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EpBdFactoryAreaModal
    },
    data () {
      return {
        description: 'ep_bd_factory_area管理页面',
        url: {
          list: "/sys/epBdFactoryArea/list",
          delete: "/sys/epBdFactoryArea/delete",
          deleteBatch: "/sys/epBdFactoryArea/deleteBatch",
          exportXlsUrl: "/sys/epBdFactoryArea/exportXls",
          importExcelUrl: "sys/epBdFactoryArea/importExcel",
          queryFactoryList: '/sys/epFactory/list',
          
        },
        dictOptions:{},
        superFieldList:[],
        factoryOptions:[],
      }
    },
    created() {
    this.initfactoryList();
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      columns(){
        if(this.language){
          return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:this.language['factory'],
            align:"center",
            sorter: true,
            dataIndex: 'factoryName'
          },
          {
            title:this.language['danger.areaCode'],
            align:"center",
            sorter: true,
            dataIndex: 'areaCode'
          },
          {
            title:this.language['danger.areaName'],
            align:"center",
            sorter: true,
            dataIndex: 'areaName'
          },
          {
            title: this.language['common.action'],
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
        }
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      //初始化厂区字典
      initfactoryList(){
		  let para={pageNo:1,pageSize:1000};
        getAction(this.url.queryFactoryList,para).then(res=>{
          if(res.success){
            this.factoryOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.factoryName, value: item.id+""}
              return c;
            })
          }
        })
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>